import { render, staticRenderFns } from "./CurrentProducts.vue?vue&type=template&id=e3581b5c"
import script from "./CurrentProducts.vue?vue&type=script&lang=js"
export * from "./CurrentProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports